import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Componentes de la página principal
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PresenceSection from './components/PresenceSection';
import MailingSection from './components/MailingSection';
import Footer from './components/Footer';

// Componentes para páginas legales
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';

// Componente que agrupa la página principal
const HomePage = () => (
  <>
    <Header />
    <HeroSection />
    <AboutSection />
    <PresenceSection />
    <MailingSection />
    <Footer />
  </>
);

const PrivacyPolicyPage = () => (
  <>
    <Header />
    <PrivacyPolicy />
    <Footer />
  </>
);

const TermsAndConditionsPage = () => (
  <>
    <Header />
    <TermsAndConditions />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Página principal */}
        <Route path="/" element={<HomePage />} />

        {/* Rutas para Política de Privacidad */}
        <Route path="/politicas-de-privacidad" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
        <Route path="/informativa-sulla-privacy" element={<PrivacyPolicyPage />} />

        {/* Rutas para Términos y Condiciones */}
        <Route path="/terminos-y-condiciones" element={<TermsAndConditionsPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/termos-e-condicoes" element={<TermsAndConditionsPage />} />
        <Route path="/termini-e-condizioni" element={<TermsAndConditionsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
